/**
 * Bartly page: loads the Noesis window from 750 px up, hands campaign
 * parameters to Noesis and keeps the page still while Noesis starts.
 */
(function () {
  'use strict';
  var appOrigin = 'https://noesis.pixelgipfel.ch';
  var frame = document.querySelector('[data-pg-bartly-frame]');
  var params = new URLSearchParams(window.location.search);
  var frameLoaded = false;

  // Only these keys travel from the shop URL to Noesis: Google Ads click IDs,
  // UTM tags and a product preset. URLSearchParams does the encoding.
  function allowedParam(key, value) {
    if (!value || value.length > 500) return false;
    if (key === 'preset') return /^[a-z0-9][a-z0-9-]{0,254}$/.test(value);
    return key === 'gclid' || key === 'gbraid' || key === 'wbraid' || /^utm_[a-z0-9_]{1,40}$/.test(key);
  }
  function handoffUrl(base) {
    var url;
    try { url = new URL(base); } catch (error) { return null; }
    if (url.origin !== appOrigin) return null;
    var taken = {};
    params.forEach(function (value, key) {
      if (taken[key] || !allowedParam(key, value)) return;
      taken[key] = true;
      url.searchParams.set(key, value);
    });
    return url.toString();
  }

  // Start button (phone) and "In neuem Tab öffnen" open the same build as the window.
  Array.prototype.forEach.call(
    document.querySelectorAll('[data-pg-bartly-open], [data-pg-bartly-newtab]'),
    function (link) {
      var href = handoffUrl(link.getAttribute('href'));
      if (href) link.href = href;
    }
  );

  function syncTheme() {
    if (!frameLoaded || !frame.contentWindow) return;
    var theme = document.documentElement.getAttribute('data-theme');
    if (theme === 'light' || theme === 'dark') {
      frame.contentWindow.postMessage({ type: 'pg:theme', version: 1, theme: theme }, appOrigin);
    }
  }

  function loadFrame() {
    if (frameLoaded) return;
    var src = handoffUrl(frame.getAttribute('data-pg-bartly-src'));
    if (!src) return;
    frameLoaded = true;
    frame.src = src;
  }

  // Noesis focuses its chat field about two seconds after loading. A focus inside
  // a cross-origin iframe makes the browser scroll the shop page down to it, and
  // the heading disappeared (test 26.10.2026). The window blur comes first, so the
  // position is still known there; scrolls in the next second are undone. This
  // stops once the visitor reaches for the window or uses the keyboard.
  var visitorReached = false;
  function reached() { visitorReached = true; }
  function holdScroll() {
    var x = window.pageXOffset;
    var y = window.pageYOffset;
    var done = false;
    function restore() {
      if (!done && (window.pageYOffset !== y || window.pageXOffset !== x)) window.scrollTo(x, y);
    }
    function stop() {
      done = true;
      window.removeEventListener('scroll', restore);
      window.removeEventListener('wheel', stop);
      window.removeEventListener('touchstart', stop);
    }
    window.addEventListener('scroll', restore, { passive: true });
    window.addEventListener('wheel', stop, { passive: true });
    window.addEventListener('touchstart', stop, { passive: true });
    window.setTimeout(stop, 1000);
  }

  if (frame) {
    frame.addEventListener('load', syncTheme);
    document.addEventListener('pg:theme-change', syncTheme);
    window.addEventListener('message', function (event) {
      if (event.origin === appOrigin && event.source === frame.contentWindow &&
          event.data && event.data.type === 'pg:theme-ready' && event.data.version === 1) syncTheme();
    });
    frame.addEventListener('pointerenter', reached);
    window.addEventListener('keydown', reached, true);
    window.addEventListener('blur', function () {
      if (frameLoaded && !visitorReached) holdScroll();
    });

    // Phones get the start card instead; the window only loads from 750 px up.
    var wide = typeof window.matchMedia === 'function' ? window.matchMedia('(min-width: 750px)') : null;
    var onWide = function (event) { if (event.matches) loadFrame(); };
    if (!wide || wide.matches) loadFrame();
    else if (wide.addEventListener) wide.addEventListener('change', onWide);
    else if (wide.addListener) wide.addListener(onWide);
  }

  var login = document.querySelector('[data-pg-bartly-login]');
  if (login) {
    var loginUrl = new URL(login.getAttribute('href'), window.location.origin);
    if (loginUrl.origin === window.location.origin) {
      loginUrl.searchParams.set('return_to', window.location.pathname + window.location.search);
      login.href = loginUrl.pathname + loginUrl.search + loginUrl.hash;
    }
  }
})();
